import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import classnames from 'classnames'
import { DropdownContent, Icon, Typography } from 'shared/ui'
import { DropdownAllContentSearchItems } from 'widgets/SearchDropdown/ui/DropdownAllSearch/DropdownAllContentSearchItems'
import { useSearchDropdownContext } from 'widgets/SearchDropdown/context/searchDropdownContext'
import styles from './styles.module.scss'

type IDropdownAllContentSearchProps = {
  onCloseMenu?: () => void
}

export const DropdownAllContentSearch: FC<IDropdownAllContentSearchProps> = observer(
  ({ onCloseMenu }) => {
    const { search, hasAllSearchFilters, options, events } = useSearchDropdownContext()

    const handleSelectSearch = () => {
      events?.onCLickSearchConversationFor?.()
      options?.handleSelectedSearch?.(search)
    }

    return (
      <DropdownContent noPadding className={classnames(styles.searchWrapper, styles['width-480'])}>
        <div className={styles.selectSearchWrap} onClick={handleSelectSearch}>
          <div className={styles.selectSearchContent}>
            <Icon icon={'search'} tertiary fontSize={20} />
            <Typography
              className={styles.selectValue}
              variant={'body-md-regular'}
              ariaLabel={'Search'}
            >
              <span className={styles.label}>Search conversations for </span>
              <span className={styles.value}>{`"${search}"`}</span>
            </Typography>
          </div>
        </div>

        {!hasAllSearchFilters && <div className={styles.divider}></div>}

        <DropdownAllContentSearchItems onCloseMenu={onCloseMenu} />
      </DropdownContent>
    )
  }
)
